module.exports = __webpack_public_path__ + "img/Modernisme_Lyrikken_i_perioden1.210155ae.jpg";